<template>
  <div class="page">
    <!-- 顶部图片 -->
    <div class="banner" v-if="getAttachmentByType(1, productAttachmentDTOList)">
      <img
        :src="'/' + getAttachmentByType(1, productAttachmentDTOList)"
        alt=""
      >
    </div>
    <!-- 主体内容 -->
    <div class="container">
      <!-- 按钮区 -->
      <div class="clBox">
        <div
          v-for="(item, index) in columnData"
          :key="item.id"
          class="cl-item"
          :class="{
            'cl-item-active': tabContentIndex === index
          }"
          @click="handleTab(item.id, index)"
        >
          <img class="icon-column" :src="item.icon" v-if="item.icon" alt="">
          <p v-html="item.columnName"></p>
        </div>

        <!-- dashed 分割线 -->
        <img
          class="dashed"
          src="../../assets/img/dashed.png"
          alt=""
        >

        <!-- 内容区 -->
        <div class="item-content">
          <div
            v-for="(item1, index1) in columnData"
            :key="index1"
          >
            <!-- 链接模板 -->
            <template v-if="tabContentIndex === index1 && item1.viewTemplate === 'linkTemplate'">
              <PageLinkTemplate
                :raw-data="materialData"
                :bottom-info="item1.richTextContents"
                :on-click="handleGoTo"
              />
            </template>
            <!-- 海报模板 -->
            <template v-else-if="tabContentIndex === index1 && item1.viewTemplate === 'playbillTemplate'">
              <PagePlaybillTemplate
                :raw-data="materialData"
                :bottom-info="item1.richTextComents"
                :on-click="handleGoTo"
              />
            </template>
          </div>
        </div>

      </div>
    </div>
    <div class="banner" v-if="getAttachmentByType(2, productAttachmentDTOList)">
      <img
        :src="'/' + getAttachmentByType(2, productAttachmentDTOList)"
        alt=""
      >
    </div>
  </div>
</template>
<script>
import PageLinkTemplate from '../../components/ui/PageLinkTemplate'
import PagePlaybillTemplate from '../../components/ui/PagePlaybillTemplate'
import wx from 'weixin-js-sdk'
export default {
  components: {
    PageLinkTemplate,
    PagePlaybillTemplate
  },
  name: 'Page',
  data () {
    return {
      // 产品id
      pageId: 1,
      // tab切换
      tabContentIndex: 0,
      // 渠道密码 009927
      password: '',
      // 渠道状态 默认 -> false
      channelFlag: false,
      // 栏目信息=切换按钮 + 对应的展示
      columnData: [],
      // 当前产品的附件集合
      productAttachmentDTOList: [],
      materialData: [],
      product: null,
      description: '',
      productName: '',
      shareImagePath: ''
    }
  },
  mounted () {
    this.configWxShareHandler()
  },
  created () {
    // 获取产品 id
    this.pageId = this.$route.query.pageId
    this.queryMarketingPageSectionList()
    this.queryProductMarketingPageDetail()
    // 请求数据
    // this.getProductById()
    // 获取按钮的 tabContentIndex
    // let tabContentIndex = localStorage.getItem('tabContentIndex')
    let tabContentIndex = sessionStorage.getItem('tabContentIndex')
    this.tabContentIndex = tabContentIndex ? Number(tabContentIndex) : 0
  },
  methods: {
    queryProductMarketingPageDetail () {
      this.axios({
        method: 'get',
        url: `api/productMarketingPage/queryProductMarketingPageDetailForShare?id=${this.pageId}`
      }).then((res) => {
        if (res.data.errorCode === 0) {
          const data = res.data.data
          this.productAttachmentDTOList = data.attachment || []
          this.description = data.description
          this.productName = data.name
          if (this.productAttachmentDTOList.length > 0) {
            this.productAttachmentDTOList.forEach(item => {
              if (item.attachmentType === 3) {
                this.shareImagePath = item.path
              } else if (this.productAttachmentDTOList.length < 3) {
                if (item.attachmentType !== 3) {
                  this.shareImagePath = '/static/img/package-icon.jpg'
                }
              }
            })
          } else {
            this.shareImagePath = '/static/img/package-icon.jpg'
          }
          console.log(this.shareImagePath)
        } else {
          this.$message({ message: res.data.errorMessage, type: 'error' })
        }
      })
    },
    // 点击按钮切换
    handleTab (id, index) {
      this.querySectionItemBySectionId(id).then(() => {
        this.tabContentIndex = index
      })
      let clItems = document.querySelectorAll('.cl-item')
      ;[].forEach.call(clItems, item => item.classList.remove('cl-item-active'))
      clItems[index].classList.add('cl-item-active')

      // localStorage.setItem('tabContentIndex', index)
      sessionStorage.setItem('tabContentIndex', index)
    },
    // 确认密码
    handleConfirm () {
      // console.log(this.password)
      // password -> 009927
      if (this.password === '123') {
        this.channelFlag = true
      } else if (this.password === '') {
        alert('请输入密码')
      } else {
        alert('密码错误!')
      }
    },
    escape2Html (data) {
      let str = JSON.stringify(data)
      let arrEntities = { lt: '<', gt: '>', nbsp: ' ', amp: '&', quot: '\\"', '#39': '\'', ldquo: '“', rdquo: '”', middot: '·' }
      data = str.replace(/&(lt|gt|nbsp|amp|quot|#39|ldquo|rdquo|middot);/ig, function (all, t) { return arrEntities[t] })
      return JSON.parse(data)
    },
    // 展示模板组件的 点击跳转方法
    handleGoTo (item) {
      console.log('click', item)

      // 素材类型 2 -> 链接
      if (item.itemType === 2) {
        // if (item.url) {
        //   window.location.href = item.url
        // } else {
        //   alert('链接无效')
        // }
        item.url ? (window.location.href = item.url) : alert('链接无效')
        // 素材类型 1 -> 图片
      } else if (item.itemType === 6) {
        console.log(item)
        let richTextComent = item.richTextContents[0]

        this.$store.commit('changeArticleContents', this.escape2Html(richTextComent))
        this.$router.push({path: '/article',
          query: {
            id: item.id
          }})
      } else {
        /*
        * 封面是: 1
        * 图标是: 2
        * */
        let curAttmentDTOList = this.filterAttachment(item.attachments)
        if (curAttmentDTOList.length === 0) {
          return alert('链接无效')
        }
        let url = curAttmentDTOList[0].path
        if (item.itemType === 1) {
          this.$router.push({
            path: '/ImagePage',
            query: {
              url: url,
              name: item.title
            }
          })
        } else if (item.itemType === 4 || item.itemType === 5) {
          this.$router.push({
            path: '/videoAndAudio',
            query: {
              url: url,
              type: item.itemType
            }
          })
        } else {
          url ? (window.location.href = url) : alert('链接无效')
        }
      }
    },
    queryMarketingPageSectionList () {
      this.axios.post('api/marketingPageSection/queryMarketingPageSectionList', {
        marketingPageId: this.pageId,
        pageIndex: 0,
        pageSize: 100
      }).then((res) => {
        if (res.data.errorCode === 0) {
          const data = res.data.data.dataList
          if (res.data.data.totalResultNumber > 0) {
            data.map(item => {
              if (item.attachment) {
                item.icon = `http://${window.location.host}/${item.attachment.path}`
              }
              this.columnData.push({
                id: item.id,
                columnName: item.name,
                icon: item.icon,
                viewTemplate: item.viewTemplate })
            })
          }
          if (this.columnData && this.columnData.length > 0) {
            this.querySectionItemBySectionId(this.columnData[this.tabContentIndex].id)
          }
        } else {
          this.$message({ message: res.data.errorMessage, type: 'error' })
        }
      }).catch(err => {
        console.log(err)
      })
    },
    querySectionItemBySectionId (id) {
      return new Promise(resolve => {
        this.axios({
          method: 'get',
          url: `api/sectionItem/queryAllSectionItemBySectionId/${id}`
        }).then((res) => {
          if (res.data.errorCode === 0) {
            const data = res.data.data
            // data.map(item => {
            this.materialData = []
            for (let i = 0; i < data.length; i++) {
              if (data[i].itemStatus === 1) {
                this.materialData.push(data[i])
              }
            }
            console.log(this.materialData)
            // item.url = `http://10.20.2.33:56790/${item.path}`
            // item.url = `http://${window.location.host}/${item.path}`
            // item.imgName = item.name.substring(0, item.name.lastIndexOf('.'))
            // })
            // this.materialData = data
            resolve()
          } else {
            this.$message({ message: res.data.errorMessage, type: 'error' })
          }
        })
      })
    },
    // 通过 id 获取产品信息
    async getProductById () {
      try {
        const {
          errorCode,
          data: { data }
        } = await this.axios.get(`/api/product/queryMaterialOfProductById/${this.productId}`)
        console.log('-> errorCode', errorCode)

        // if (errorCode) {
        //   alert('当前产品不存在')
        //   return this.$router.back()
        // }

        console.log('-> 产品信息 data', data)
        // 修改 title 名称
        this.product = data
        document.title = data.productShortName
        this.columnData = data.queryMaterialColumnOutputDTOS
        // console.log('-> this.columnData', this.columnData)
        this.productAttachmentDTOList = data.attachments || []
        // console.log('-> this.productImage', this.productAttachmentDTOList)
        this.configWxShareHandler()
      } catch (err) {
        alert('当前产品不存在')
        return this.$router.back()
      }
    },
    getLen (o) {
      return Array.isArray(o) ? o.length : Object.keys(o).length
    },
    // 获取指定附件类型的 path
    getAttachmentByType (t, attachmentList) {
      if (!attachmentList) {
        return false
      }
      for (let e of attachmentList) {
        if (e && e.attachmentType === t) {
          return e.path
        }
      }
      return false
    },
    // 过滤附件类型 1 和 2
    filterAttachment (attachmentList) {
      return attachmentList.filter(item => {
        return !(item.attachmentType === 1 || item.attachmentType === 2)
      })
    },
    configWxShareHandler () {
      let wxConfigFlag = sessionStorage.getItem('wxConfigFlag')
      if (wxConfigFlag !== 'true') {
        // console.log('wait config complete')
        window.setTimeout(this.configWxShareHandler, 100)
      }
      let host = window.location.protocol + '//' + window.location.host + '/'
      // let iconPath = this.getAttachmentByType(10, this.productAttachmentDTOList)
      let iconPath = this.shareImagePath
      // console.log('icon path :' + host + iconPath)
      wx.updateAppMessageShareData({
        title: this.productName + '资料包',
        desc: this.description, // 分享描述
        link: window.location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        imgUrl: host + iconPath, // 分享图标
        success: function () {
          // 设置成功
          console.log('微信分享成功')
        }
      })
      wx.updateTimelineShareData({
        title: this.productName + '资料包',
        link: window.location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        imgUrl: host + iconPath, // 分享图标
        success: function () {
          // 设置成功
          console.log('朋友圈分享成功')
        }
      })
    }
  }
}
</script>
<style
  lang="scss"
  scoped
>
  * {
    box-sizing: border-box;
  }

  .page {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100vw;
    height: auto;
    background-color: #efeff1;

    .banner {
      width: 100vw;
      height: 4.853rem;
      //background-color: skyblue;
      img {
        width: 100%;
        height: 100%;
      }
    }

    .container {
      width: 8.84rem;
      //height: 400px;
      padding: 0.467rem 0.2rem;
      margin: 0.48rem 0 0.307rem 0;
      background-color: #FFFFFF;
      border-radius: 0.4rem;
      /* 按钮区 */
      .clBox {
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;

        .cl-item {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 3.787rem;
          height: 0.96rem;
          margin: 0 0 0.507rem 0;
          font-size: 0.373rem;
          color: #FFFFFF;
          background-color: #2f8cec;
          box-shadow: 0 1px 5px rgba(0, 75, 153, 0.3);
          border-radius: 0.96rem;

          // 字体图标
          //i {
          //  font-size: 0.64rem; // 24px
          //  margin: 0 0.267rem 0 0;
          //}
          .icon-column {
            width: 0.64rem;
            height: 0.64rem;
            margin: 0 0.267rem 0 0;
          }

          p {
            display: inline-block;
            line-height: 1;
          }
        }
      }

      /* 分隔线 dashed */
      .dashed {
        width: 100%;
        height: 0.027rem;
        border: 0;
      }

      /* 内容区 */
      .item-content {
        width: 100%;
        padding: 0.533rem 0 0 0;
        /* todo 背景颜色 */
        //background-color: pink;
        /* 基础材料 */
        .item1-content-raw {
          .item1 {
            display: flex;
            align-items: center;
            width: 100%;
            padding: 0.133rem 0.267rem;
            margin: 0 0 0.293rem 0;
            font-size: 0.373rem;
            color: #FFFFFF;
            background-color: #2f8cec;
            border-radius: 0.267rem;

            i {
              font-size: 0.533rem;
              margin: 0 0.133rem 0 0;
            }
          }
        }

        /* 渠道材料 */
        .password-box {
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          width: 100%;
          height: 6.667rem;
          //background-color: #fff;
          //background: purple;
          .input-password {
            width: 4.4rem;
            height: 1.2rem;
            font-size: 0.533rem;
            color: #7f7f7f;
            text-align: center;
            border: 2px #13346a solid;
            border-radius: 0.2rem;
          }

          .div-confirm {
            width: 4.4rem;
            height: 1.2rem;
            margin: 0.333rem 0 0 0;
            font-size: 0.533rem;
            color: #ffffff;
            text-align: center;
            line-height: 1.173rem;
            background: #13346a;
            border-radius: 0.2rem;
          }
        }

        /* 宣传海报 */
        .poster-container {
          display: flex;
          flex-wrap: wrap;

          .poster-box {
            width: 33.33%;
            display: flex;
            flex-direction: column;

            img {
              width: 2rem;
              height: 2rem;
            }

            p {
              width: 2rem;
              padding: 0.333rem 0 0.333rem 0;
              text-align: center;
            }
          }

          .poster-box:nth-of-type(3n - 1) {
            align-items: center;
          }

          .poster-box:nth-of-type(3n) {
            align-items: flex-end;
          }
        }

        /* 媒体报道 */
        .media-container {
          .media-item {
            display: flex;
            align-items: center;
            width: 100%;
            //height: 0.8rem;
            padding: 0.133rem 0.267rem;
            margin: 0 0 0.293rem 0;
            font-size: 0.373rem;
            color: #FFFFFF;
            background-color: #2f8cec;
            border-radius: 0.267rem;

            i {
              font-size: 0.533rem;
              margin: 0 0.133rem 0 0;
            }
          }
        }
      }
    }
  }

  /* 底部文字 */
  .fxtip {
    width: 100%;
    padding: 0.4rem 0 0;
    //font-size: 0.187rem;
    font-size: 0.3rem;
    line-height: 0.267rem;
    color: #070707;
  }

  /* tab 高亮 */
  .cl-item-active {
    background-color: #005ebf !important;
    transition: 0.3s;
  }

  /* 测试 icon 的编写 */
  .icon {
  }
</style>



// WEBPACK FOOTER //
// src/views/page-generator/ProductPage.vue